<div class="report-list-container">
  <div class="header" id="report-header">

    <picture class="Coca-Cola-Company-Logo">
      <source media="(min-width: 1200px)">
      <a href="">
        <img src="../assets/image/Coke-company-logo-black.svg" loading="lazy" itemprop="contentUrl"
          alt="Coca Cola Company Logo">
      </a>
    </picture>

    <h1 id="portal-title">Martech Reporting Tool</h1>

    <button id="protal-home" mat-button (click)="goToHome()">Home</button>

   
    <button mat-button class="Logout-Login" (click)="signOutSignIn()">{{this.signOutSignInLabel}}</button>


  </div>

  <div *ngIf="loading" class="loading-spinner" class="loading-overlay">
    <mat-spinner diameter="25" ></mat-spinner>
  </div>

  <div id="path-navigation" *ngIf="!loading && pathNavigation" [class.showBreadcrumb]="this.showBreadcrumb">
    <span> > </span>
    <span *ngFor="let navigation of pathNavigation">
      <a id="path-navigation-text" href="javascript:void(0)" (click)="goToFolder(navigation.path)">
        {{ navigation.name }} >
      </a>
      <!-- <span id="path-navigation-text" (click)="goToFolder(navigation.path)">
        {{ navigation.name }}
      </span> -->
      <!-- <span id="path-navigation-text">/</span> -->
    </span>
  </div>

  <div class="password-container">
    <div id="password-div" [class.hidePasswordButton]="this.hidePasswordButton">
      <span id="password-text" class="mdc-button mat-mdc-button mat-unthemed mat-mdc-button-base">Please click here to enter your file path -> </span> 
      <button mat-button (click)="openPasswordDialog()"
        class="password-button">
        Open Folder
      </button>
    </div>
    <span id="password-desc" [class.hidePasswordButton]="this.hidePasswordButton">(copy the file path and password from your welcome email)</span>
  </div>
  

  <div id="report-container" *ngIf="!loading && reportList.length > 0">
    <table id="report-table" [class.showTableHeader]="this.showTableHeader">

      <tr *ngIf="this.showTableHeader; else elseBlockName">
        <td id="report-name">Report Name</td>
        <td>Data Time</td>
        <td>Size</td>
        <td id="report-download-button">Action</td>
      </tr>
      <ng-template #elseBlockName>
        <tr></tr>
      </ng-template>


      <tr></tr>

      <tr *ngFor="let file of reportList">
        <td id="report-name" *ngIf="file.TypeFile; else elseBlockName">
          <a id="report-folder-name" href="javascript:void(0)" (click)="openDownloadPasswordDialog(file.BucketKey)">
            {{ file.FileName }}
          </a>
        </td>
        <ng-template #elseBlockName>
          <td id="folder-name">
            <a id="report-folder-name" href="javascript:void(0)" (click)="goToFolder(file.Path)">
              {{ file.CurrentPath }}/
            </a>
          </td>
        </ng-template>

        <td *ngIf="file.TypeFile; else elseBlockSize">
          <span id="report-date">{{ file.LastModified }}</span>
        </td>
        <ng-template #elseBlockSize>
          <td>
            <span id="report-date"></span>
          </td>
        </ng-template>

        <td *ngIf="file.TypeFile; else elseBlockSize">
          <span id="report-size">{{ file.Size/1024/1024 | number: '1.3-3' }} MB</span>
        </td>
        <ng-template #elseBlockSize>
          <td>
            <span id="report-size"></span>
          </td>
        </ng-template>

        <td id="report-download-button" *ngIf="file.TypeFile; else elseBlockOption">
          <button id="download-button" mat-button (click)="openDownloadPasswordDialog(file.BucketKey)">Download</button>
        </td>
        <ng-template #elseBlockOption>
          <td id="report-download-button">
            <button mat-button (click)="goToFolder(file.Path)">/</button>
          </td>
        </ng-template>
      </tr>
    </table>
  </div>
</div>


<script>
  if (global === undefined) {
    var global = window;
  }
</script>
